import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ArrowTriangleBlack } from '../../../asset/icon/ArrowTriangleBlack'
import { setOpenSectionIdInSides, setValueOptions } from '../../../store/actions/setting';
import { getOpenSectionIdInSides, getValueOption, valueOption } from '../../../store/selectors/selectors';
//@ts-ignore
import s from './ColorSelectionSection.module.scss'


type colorT = {
    id: string,
    name: string,
    color: string,
}

type ColorSelectionSectionT = {
    label: string,
    values: colorT[],
    id: string,
    children: any,
    [key: string]: unknown
}
export const ColorSelectionSection = ({ ...props }: ColorSelectionSectionT) => {

    const { label, key, values, id, parentKeySection, children } = props;
    const dispatch = useDispatch();
    const [activeColor, setActiveColor]: any = useState()


    let openSectionIdInSides: string = useSelector(getOpenSectionIdInSides);
    const onSelect = (props: any) => {
        dispatch(setOpenSectionIdInSides({ idSection: id }))
    }

    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({ idOptions: id, parentKeySection })(state));
    const onChangeColor = (value: colorT) => {
        dispatch(setValueOptions({ idParams: id, valueParam: value['id'] }))
    }


    let sectionClass = `${s.selectSection}`
    if (openSectionIdInSides === id) sectionClass += `  ${s.selectSection_Active}`;

    let style: any = {};

    useEffect(() => {
        let activeColor: colorT = values.filter((item: colorT) => item['id'] === selectValue)[0]
        setActiveColor(activeColor && activeColor['name'])
    }, [selectValue])


    return (
        <div className={sectionClass}   >
            <div className={s.header} onClick={() => onSelect(props)}>
                <div className={s.title}>{label}</div>
                <div className={s.info}>
                    <div className={s.value}>{activeColor}</div>
                    <div className={s.icon}>  <ArrowTriangleBlack /></div>
                </div>
            </div>
            <div className={s.main} >
                <div className={s.boxColor} style={style}  >
                    {values.map((item: colorT) => {

                        let classItem = `${s.item}`

                        if (item['id'] === selectValue) classItem += ` ${s.active}`

                        return (<div className={classItem} key={item['id']} onClick={() => onChangeColor(item)} >
                            <div className={s.color}></div>
                            <div className={s.name}>{item['name']}</div>
                        </div>)
                    })}

                </div>
                {!!children && (<div className={s.boxAllProperty}> {children} </div>)}

            </div>


        </div>
    )
}
